export default [
    {
        path: 'relatorio-financeiro-exame',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-relatorio-financeiro-exame' */
            '@/views/exame-imagem/relatorio-financeiro-exame/Index'),
        redirect: 'relatorio-financeiro-exame/index',
        children: [
            {
                name: 'exame-imagem-relatorio-financeiro-exame-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-relatorio-financeiro-exame' */
                    '@/views/exame-imagem/relatorio-financeiro-exame/List.vue'),
            },
        ],
    },
]